import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import OrderMain from "../components/OrderMain";

function Order(){
    return(
        <>
        <Header />
        <OrderMain />
        <Footer />
        </>
);
}

export default Order; 